class Contact {
    private namespace: HTMLElement | null;
    private form: HTMLFormElement | null;
    private thankyou: HTMLElement | null;
     
    constructor() {
        this.namespace = document.getElementById('page-contact');    
        this.form = null;
        this.thankyou = null;
        this.initPage();
    }

    private initPage(): void {
        if (!this.namespace) return;
        this.form = document.getElementById('contact-form') as HTMLFormElement;
        this.thankyou = document.getElementById('thankyou');

        if (this.form) {
            this.form.addEventListener('submit', this.handleSend.bind(this));
        }
    } 

    private handleSend(e: any): void {
        e.preventDefault();
        
        if (!this.form || !this.thankyou) return;

        const formData = new FormData(this.form);
        const name = formData.get("name");
        const email = formData.get("email");
        const message = formData.get("message");
        const phone = formData.get("phoneNumber");
        const reason = formData.get("reason");

        if (!name || !phone || !message || !email || !reason) {
            return;
        }
        
        const send = async (): Promise<void> => {    
            await fetch(
                `/.netlify/functions/sendContactForm`,
                {
                  method: "POST",
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    name,
                    email,
                    phone,
                    from: "website@pauloakenfold.com",
                    subject: "Contact Form Submission",
                    reason, 
                    message,
                  }),
                }
              );
        };

        send();
        this.form.style.display = "none";
        this.thankyou.style.display = "block";
    }
}

export default Contact;